import { IconButtonStyled } from './styles'
import { TIconButton } from './types'

export const Icon: React.FC<TIconButton> = (props) => <IconButtonStyled {...props} />
